export const preGameFailedReasonEnum = {
  MAINTENANCE: 'maintenance',
  ZERO_BALANCE: 'zero_balance'
}

export const gameThemeEnum = {
  NO_CATEGORY: 'NO_CATEGORY'
}

export const gameCategoryEnum = {}



// WEBPACK FOOTER //
// ./src/constants/game.js